import { ButtonProps } from '@mui/material';
import { useHistory } from 'react-router-dom';
import { useStopImpersonating } from '../../sic-lib/api/hooks/useSupport';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import { requestVerifyAuth } from '../../store/users';
import ButtonLoading from '../Shared/ButtonLoading';

interface Props extends ButtonProps {}

export function ButtonStopImpersonating({ ...rest }: Props) {
    const dispatch = useAppDispatch();
    const history = useHistory();
    const {
        mutateAsync: stopImpersonating,
        isPending: isLoading,
        isError,
        isSuccess,
    } = useStopImpersonating();
    const isImpersonated = useAppSelector(state => state.user.isImpersonated);

    const handleClick = async () => {
        try {
            await stopImpersonating();
            console.log('stopImpersonating: succeeded');
        } catch (e) {
            console.log('stopImpersonating: error:', e);
        }
        dispatch(requestVerifyAuth());
        history.push('/');
        window.location.reload();
    };

    if (!isImpersonated) {
        return null;
    }

    return (
        <ButtonLoading
            {...rest}
            isLoading={isLoading}
            isSuccess={isSuccess}
            isError={isError}
            variant="outlined"
            color="secondary"
            onClick={handleClick}
        >
            Stop Impersonating
        </ButtonLoading>
    );
}
